// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesNeo4jPlugin
 */
export interface TypesNeo4jPlugin {
  /**
   *
   * @type {string}
   * @memberof TypesNeo4jPlugin
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof TypesNeo4jPlugin
   */
  sourceFile?: string;
}

/**
 * Check if a given object implements the TypesNeo4jPlugin interface.
 */
export function instanceOfTypesNeo4jPlugin(
  value: object,
): value is TypesNeo4jPlugin {
  return true;
}

export function TypesNeo4jPluginFromJSON(json: any): TypesNeo4jPlugin {
  return TypesNeo4jPluginFromJSONTyped(json, false);
}

export function TypesNeo4jPluginFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesNeo4jPlugin {
  if (json == null) {
    return json;
  }
  return {
    name: json['Name'] == null ? undefined : json['Name'],
    sourceFile: json['SourceFile'] == null ? undefined : json['SourceFile'],
  };
}

export function TypesNeo4jPluginToJSON(json: any): TypesNeo4jPlugin {
  return TypesNeo4jPluginToJSONTyped(json, false);
}

export function TypesNeo4jPluginToJSONTyped(
  value?: TypesNeo4jPlugin | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Name: value['name'],
    SourceFile: value['sourceFile'],
  };
}
